<template>
  <div>
    <b-table
      striped
      hover
      :items="listaPrestazioni"
      responsive
      stacked="lg"
      :current-page="currentPage"
      :per-page="perPage"
      :fields="fieldsPrestazioni"
      selectable
      select-mode="single"
      @row-selected="onRowSelected"
    >
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <div class="divcheck">
            <span aria-hidden="true">&check;</span>
          </div>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
    </b-table>
    <template>
      <b-row>
        <b-col cols="6">
          <strong class="text-primary"> Sono presenti {{ rows }} prestazioni</strong>
        </b-col>
        <b-col cols="6">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    listaPrestazioni: Array,
  },
  data() {
    return {
      fieldsPrestazioni: [
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
          sortable: true,
        },
        {
          label: "Codice Prestazione",
          key: "codicePrestazione",
        },
        {
          label: "Selezionato",
          key: "selected",
          thStyle: "width: 6rem",
        },
      ],
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    rows() {
      return this.listaPrestazioni.length;
    },
  },
  methods: {
    onRowSelected(item) {
      let me = this;
      me.prestazioneSelezionata = item;
      me.$emit("getPrestazioneSelezionata", me.prestazioneSelezionata);
    },
  },
};
</script>
